<template>
  <Notifications />
</template>

<script>
import Notifications from '@/components/common/Notifications.vue'

export default {
  name: 'NotificationsPage',
  components: { Notifications }
}
</script>

<style scoped>

</style>
